module.exports = __webpack_public_path__ + "static/img/zb1-5.861d4bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/zb1-5.png
// module id = 735
// module chunks = 0